export default "__VITE_ASSET__pmEckwSa__"